export enum AcceptModalState {
    IDLE,
    OPENED,
    ACCEPTED,
    CANCELLED,
}